import React from 'react';
import Card from '@mui/material/Card';
import {Grid, TextField} from '@mui/material';
import {useFormikContext} from 'formik';

export default function TransferEntryTwo({code}) {
  const {values} = useFormikContext();

  const getDisplayValue = (value) => {
    if (!value) return '';
    if (typeof value === 'object') {
      return value?.name || value?.code || '';
    }
    return value;
  };

  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4, pb: 5}}>
        {values?.dimensions && values?.dimensions?.length > 0 && (
          <Grid container spacing={1.5}>
            {values?.dimensions?.map((dimension, dimIndex) => {
              return dimension?.items?.map((item, itemIndex) => (
                <Grid item sm={6} xs={12} key={`${dimIndex}-${itemIndex}`}>
                  <TextField 
                    variant={'outlined'} 
                    size={'small'} 
                    fullWidth 
                    label={item?.label}
                    value={`${item?.value || ''} ${item?.unit || ''}`}
                    disabled
                    InputLabelProps={{
                      style: {fontSize: 14, color: '#929191'},
                      shrink: true,
                      marginDense: false
                    }}
                  />
                </Grid>
              ))
            })}
          </Grid>
        )}
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Dyes'}
          value={getDisplayValue(values?.dyes)}
          disabled
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Motifs'} 
          value={getDisplayValue(values?.motifs)}
          disabled
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Description'}
          multiline 
          rows={5} 
          value={getDisplayValue(values?.description)}
          disabled
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
      </Card>
    </div>
  );
}